import { LicenseTypeTable } from "./view/LicenseTypeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const LicenseType = () => {
  const viewPermission = PERMISSIONS.permission_utilities_licensetype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <LicenseTypeTable /> : ""}</>
  );
};

export default LicenseType;